document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('header'); // adjust selector as needed
  var offCanvasElements = document.querySelectorAll('.off-canvas'); // adjust selector

  function updateOffCanvasPosition() {
    var headerHeight = header.getBoundingClientRect().height;

    offCanvasElements.forEach(function(el) {
      el.style.paddingTop = headerHeight + 'px';
      el.style.height = '100%';
    });
  }

  // Modern, robust: fires whenever header's actual size changes for any reason
  if (window.ResizeObserver) {
    var resizeObserver = new ResizeObserver(function() {
      updateOffCanvasPosition();
    });
    resizeObserver.observe(header);
  } else {
    // Fallback for older browsers: debounced window resize
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateOffCanvasPosition, 100);
    });
  }

  // Foundation's breakpoint-change event (still fires as a native event, no jQuery needed)
  window.addEventListener('changed.zf.mediaquery', function() {
    updateOffCanvasPosition();
  });

  // Initial calculation, plus one more after full load (fonts/images can shift height)
  updateOffCanvasPosition();
  window.addEventListener('load', updateOffCanvasPosition);
});

document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector('.menu-toggle[data-toggle="off-canvas"]');
  const canvas = document.getElementById("off-canvas");
  if (!btn || !canvas) return;

  const setState = (open) => {
    btn.classList.toggle("is-active", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    btn.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  };

  // 1) Always animate immediately on button click
  btn.addEventListener("click", () => {
    setState(!btn.classList.contains("is-active"));
  });

  // Helper: detect current open state (Foundation typically toggles .is-open + aria-hidden)
  const isCanvasOpen = () =>
    canvas.classList.contains("is-open") ||
    canvas.getAttribute("aria-hidden") === "false";

  // 2) Sync with Foundation events (when they fire)
  const onClosed = () => setState(false);
  const onOpened = () => setState(true);

  // Some builds dispatch on the element…
  canvas.addEventListener("closed.zf.offCanvas", onClosed);
  canvas.addEventListener("opened.zf.offCanvas", onOpened);

  // …and some dispatch on document (more reliable across setups)
  document.addEventListener("closed.zf.offCanvas", () => {
    if (!isCanvasOpen()) onClosed();
  });
  document.addEventListener("opened.zf.offCanvas", () => {
    if (isCanvasOpen()) onOpened();
  });

  // 3) Fallback: observe class/aria changes so overlay/area click ALWAYS re-syncs
  const mo = new MutationObserver(() => setState(isCanvasOpen()));
  mo.observe(canvas, { attributes: true, attributeFilter: ["class", "aria-hidden"] });

  // Initial
  setState(isCanvasOpen());
});